import { ClickableText } from "@components/clickable/Clickable.styles";
import React from "react";
import { isNotDefined } from "@utils/general";

/**
 * Linkify URLs in a string [HTTP(s) links and emails]
 * @param text
 */
export const Linkify: React.FC<{ text: string }> = ({ text }) => {
    if (isNotDefined(text)) {
        return <></>;
    }
    // pattern to match URLs and email addresses
    const pattern = /(\bhttps?:\/\/[^\s]+|\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/gi;

    const parts = text.split(pattern);

    if (parts.length === 1 && parts[0] === text) {
        // no links found, return original text without extra wrapper elements
        return <>{text}</>;
    }

    return (<>
        {parts.map((part, i) => {
            let url = part;
            if ([".", ",", ";", ":", "?", "!"].includes(url[url.length - 1])) {
                url = url.slice(0, -1);
            }
            if (/^https?:\/\//i.test(part)) {
                return (
                        <ClickableText key={i}
                                       href={url}
                                       target="_blank"
                                       rel="noopener noreferrer"
                                       $hasLinkStyle>
                            {part}
                        </ClickableText>
                );
            } else if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(part)) {
                return (
                        <ClickableText key={i}
                                       href={`mailto:${url}`}
                                       $hasLinkStyle>
                            {part}
                        </ClickableText>
                );
            } else {
                return <React.Fragment key={i}>{part}</React.Fragment>;
            }
        })}
    </>);
};